import type { KanbanTutor } from './interfaces'

import dayjs from 'dayjs'

import { resolveUrl } from '@shared/lib/url'
import { useCanonicalRoute } from '@shared/lib/routes'
import { AppRoute } from '@shared/config'

interface TutorKanbanStageReturn {
  isExpired: (deadline: string | null) => boolean
  isUpcoming: (deadline: string | null) => boolean
  getAgentName: (tutor: KanbanTutor) => string | null
  handleCardClick: (id: number) => void
}

export const useTutorKanbanStage = (): TutorKanbanStageReturn => {
  const { saveCanonicalUrl } = useCanonicalRoute({ key: 'tutor-kanban-referrer' })

  const isExpired = (deadline: string | null): boolean => {
    if (!deadline) {
      return false
    }
    return dayjs(deadline).isBefore(dayjs())
  }

  const isUpcoming = (deadline: string | null): boolean => {
    if (!deadline || isExpired(deadline)) {
      return false
    }
    return dayjs(deadline).diff(dayjs(), 'hour') <= 24
  }

  const getAgentName = (tutor: KanbanTutor): string | null => {
    return tutor.agent?.name ?? null
  }

  const handleCardClick = (id: number): void => {
    saveCanonicalUrl()

    const url = resolveUrl(AppRoute.TutorKanbanInfo, { id })

    void navigateTo(url)
  }

  return {
    isExpired,
    isUpcoming,
    getAgentName,
    handleCardClick,
  }
}
